import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import translationEn from './en';
import translationPl from './pl';

const resources = {
  pl: translationPl,
  en: translationEn,
};

i18n.use(initReactI18next).init({
  resources,
  ns: ['common'],
  defaultNS: 'common',
  fallbackLng: 'pl',
  interpolation: {
    escapeValue: false,
  },
  keySeparator: '.',
});

export default i18n;
